
import { getBroswerVersion, compareVersion } from '~/utils/common'

let broswerVersion = getBroswerVersion();

 //是 Safari 且 版本 < 14
function isSafariLt14 () {
    if (broswerVersion.broswer !== 'Safari') {
        return false;
    }
    return compareVersion(broswerVersion.version, "14.0.0") < 0
}



// 修复 ios 12 ，当自定义固定高度的元素 overflow-y: auto 时滚动卡顿问题。
if(isSafariLt14()) {
    document.body.style['-webkit-overflow-scrolling'] = "touch";
}

